import { ZollAPIService } from '../../../services/zollApi.service'
import { clientData } from '../../../services/clientData.service'
import { zollBaseURL } from '../../../services/api.service'
import { ZollApiResponse } from '../../zollApi/store/zollApi.types'

const clientDataImportUrl = `${zollBaseURL}/api/ClientData/retrieve`

export interface IClientDataResponse extends ZollApiResponse {
  data: clientData
}

export type clientDataReq = Array<{ id: string; createDateTime: string }>

export interface IClientDataRequest {
  clientData: clientDataReq
}

export class ClientDataImportService extends ZollAPIService {
  async getClientData(data: IClientDataRequest): Promise<IClientDataResponse> {
    return this.postWithError(clientDataImportUrl, data)
  }
}
